import { getScoreColor } from '../utils/scoring';

export default function TickSlider({ value, onChange, min = 0, max = 10, step = 0.5, showValue = true }) {
  const color = getScoreColor(value);
  const pct = ((value - min) / (max - min)) * 100;

  const wholeNumbers = [];
  for (let i = min; i <= max; i++) wholeNumbers.push(i);

  return (
    <div className="py-2 sm:py-1">
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className="tick-slider w-full h-8 sm:h-auto touch-none"
        style={{
          '--pct': `${pct}%`,
          '--color': color.hex || '#C9A668',
        }}
      />
      <div className="flex justify-between px-[2px] mt-1">
        {wholeNumbers.map((n) => (
          <span
            key={n}
            className={`text-[10px] sm:text-[8px] w-0 text-center ${n === Math.round(value) ? 'text-white font-bold' : 'text-neutral-600'}`}
          >
            {n}
          </span>
        ))}
      </div>
    </div>
  );
}
